<style lang="stylus">
.input-group
    input
        height 49px
        border none
        width 80%
    .clear-button
        float right
        width 49px
        height 49px
        img
            height 15px
            width 15px
            margin 17px 10px 0
</style>
<template>
    <div class="input-group">
        <div class="clear-button" v-show="isButtonShow" @click="clearVal">
            <img  src="../../image/preorder/delete.png" alt="" >
        </div>
        <input  :maxlength="maxlen" v-model="value" :placeholder="placeholder" @input="inputVal" @focus="showBtn" @blur="hideBtn" >
    </div>
</template>
<script>
    export default {
        props:['type','maxlen','val','placeholder','index'],
        data() {
            return {
                isButtonShow: false,
                sto: {}
            }
        },
        computed:{
            value:{
                get(){
                    return this.val
                },
                set(val){
                    this.$emit("val-change",val,this.index)
                }
            }
        },
        methods: {
            inputVal(event) {
                let self = this
                clearTimeout(this.sto);
                // this.$emit("val-change",event.target.value,this.index)
                this.sto = setTimeout(() =>{
                    event.target.blur()
                    self.hideBtn()
                },4000)
            },
            clearVal(event) {
                this.value = ''
                
                this.$emit("val-change",'', this.index)
            },
            showBtn(event) {
                clearTimeout(this.sto);
                this.isButtonShow = true
                this.$emit("input-focus")
                let self = this
                this.sto = setTimeout(() =>{
                    event.target.blur()
                    self.hideBtn()
                },4000)
            },
            hideBtn() {
                setTimeout(() => {
                    this.isButtonShow = false
                },1000)
                this.$emit("input-blur")
            }
        }
    }
</script>